import type { FC } from "react"

import { ConfirmationTemplate } from "./ConfirmationTemplate"

interface CancelTemplateProps {
  title?: string
  message?: string
  closeLabel?: string
  confirmLabel?: string
  onClose: (isOpen: boolean) => void
  onConfirm: () => void
}

/**
 * @deprecated Use `CancelDialog` component instead.
 */
export const CancelTemplate: FC<CancelTemplateProps> = ({
  onClose,
  onConfirm,
  title = "Oh no! Are you sure you want to cancel?",
  message = "By cancelling now, your information will not be saved. Click on “Go Back” if this action was a mistake.",
  closeLabel = "Go Back",
  confirmLabel = "Yes, Cancel",
}) => {
  const handleClose = () => onClose(false)

  const handleConfirm = () => {
    onConfirm()
    onClose(false)
  }

  return (
    <ConfirmationTemplate
      title={title}
      content={message}
      closeLabel={closeLabel}
      confirmLabel={confirmLabel}
      isWarning
      onClose={handleClose}
      onConfirm={handleConfirm}
    />
  )
}
